import Compute from '../public/compute.svg';
import Storage from '../public/storage.svg';

export const migratorList = [
  {
    subtitle: 'benefits.easy.title',
    subdescription: 'benefits.easy.description'
  },
  {
    subtitle: 'benefits.automation.title',
    subdescription: 'benefits.automation.description'
  },
  {
    subtitle: 'benefits.control.title',
    subdescription: 'benefits.control.description'
  },
  {
    subtitle: 'benefits.saving.title',
    subdescription: 'benefits.saving.description'
  },
  {
    subtitle: 'benefits.agents.title',
    subdescription: 'benefits.agents.description'
  },
  {
    subtitle: 'benefits.autoconfiguration.title',
    subdescription: 'benefits.autoconfiguration.description'
  }
];

export const stepMigrator = ['addAws', 'import', 'reconfigure', 'resources', 'scripts'];

export const relatedServices = [
  {
    title: 'Compute',
    img: Compute,
    link: '/compute'
  },
  {
    title: 'Storage',
    img: Storage,
    link: '/storage'
  }
];
